import view from 'bundle-text:../dom/404.html'; // eslint-disable-line
import app from './app';

export default () => {
  const content = document.createElement('div');
  content.classList.add('align-items-center');
  content.classList.add('d-flex');
  content.classList.add('h-100');
  content.classList.add('justify-content-center');
  content.classList.add('w-100');
  content.innerHTML = view;

  const title = `${app.run.settings.view[404].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  console.log(document.title);
  document.title = '';
  document.title = title;
  console.log(document.title);
  //document.title = `${app.run.settings.view[404].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
  //document.title = 'SATAN!';

  return content;
};
